import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@knockrentals/knock-shared-web-v2';
import { makeCss } from '../../make-css';

const useCss = makeCss({
  selectedRowsMessage: {
    padding: '16px',
    '&.body2': {
      fontWeight: 600,
    },
  },
});

const PaginationMessage = ({ message }) => {
  const css = useCss();
  return (
    <Typography css={css.selectedRowsMessage} variant="body2">
      {message}
    </Typography>
  );
};

PaginationMessage.propTypes = {
  message: PropTypes.string,
};

export default PaginationMessage;
